export class FormLane{
    id ;
    title  ;
    description ;
    cards = new Array();
}
